import React from "react";

export default function FilterIconMarket({ fill }) {
  return (
    <svg
      width="8"
      height="4"
      viewBox="0 0 8 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.63672 3.62695L4.01001 0.000248592L0.38331 3.62695L7.63672 3.62695Z"
        fill={fill}
      />
    </svg>
  );
}
